import React from 'react'
import styled from 'styled-components'

import gif from '../../../../img/Elevate-Security-Animated-Logo.gif'

const LoadingScreenView = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Loading = () => (
  <div className="row" style={{ height: '65vh' }}>
    <LoadingScreenView>
      <img src={gif} alt="Loading..." height="200" width="200" />
    </LoadingScreenView>
  </div>
)

export default Loading
